/*
 * MDB shim for ModalHeader
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/CreateModal.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/Orders/RecurringOrders.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/liaisonModal.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/deliveryAcknowledgements.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/productTypes.jsx
 * - src/Seating/Settings/reasons.jsx
 * - src/Seating/Settings/trainingLink.jsx
 */

import MUIDialogTitle from "@mui/material/DialogTitle";

export default function ModalHeader({ children, toggle, ...rest }) {
    return (
        <MUIDialogTitle {...rest} onClick={toggle}>
            {children}
        </MUIDialogTitle>
    );
}
